import React from 'react';
import { Meta, DataEmpty } from '@/components';
import intl from 'react-intl-universal';

const App = () => {
    return (
        <>
            <Meta title={intl.get('App.ServerException').d('500 - 服务器异常')} description="" keywords="" ogImage="" />
            <DataEmpty emptyText={intl.get('App.ServerException').d('500 - 服务器异常')} />
        </>
    );
};

export default App;

App.getLayout = (page: any) => <>{page}</>;
